import advieskeuze from '@/assets/advieskeuze-logo.svg';

const AdvieskeuzeReviews = () => {
  return <section className="py-12 bg-muted/50" aria-labelledby="advieskeuze-heading">
      <div className="container mx-auto px-4">
        {/* Advieskeuze Reviews */}
        <div className="rounded-lg p-8 bg-inherit">
          <div className="text-center mb-6">
            <div className="flex items-center justify-center mb-4">
              <img src={advieskeuze} alt="Advieskeuze logo" className="h-8 mr-3" />
              <h2 id="advieskeuze-heading" className="text-2xl font-bold text-secondary">Reviews</h2>
            </div>
            <p className="text-muted-foreground">Onafhankelijke beoordelingen van onze dienstverlening</p>
          </div>
          <div className="flex justify-center">
            <iframe src="https://www.advieskeuze.nl/go/banner?id=318464e2-521c-49c5-9a86-a232db328a96&amp;slug=scoreenreviewspagina&amp;properties=AfAcDBAEAAwQBgAFAASABIBMRcGlldGVyLXZhbi1oZXVzZGVuAAA" width="100%" height="600" style={{
            border: 0,
            overflow: 'hidden'
          }} title="Advieskeuze Reviews" />
          </div>
        </div>
        
        <br /><br />
        
        <div className="text-center mb-12">
          <a href="https://www.advieskeuze.nl/verzekeringsadvies/3315kt/compleet-verzekerd/beoordelingen" className="inline-flex items-center text-primary hover:text-primary-dark font-semibold focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded px-2 py-1" target="_blank" aria-label="Bekijk alle reviews op Advieskeuze (opent in nieuw venster)">
            Bekijk alle reviews op Advieskeuze
            <svg className="w-4 h-4 ml-2" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </section>;
};
export default AdvieskeuzeReviews;